// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__iLUe8","buttons":"PendingPaymentAlert_buttons__3Da2t"};